import React, { Component, Fragment } from 'react';
import _ from 'lodash';

import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';

export default class ToggleField extends Component {
  hostId = getId('tooltipHost');

  componentWillMount() {
    this.id = _.uniqueId('ToggleField');
  }

  render() {
    const { label, tooltip, checked, ...rest } = this.props;

    const tooltipIcon = (
      <Fragment>
        {tooltip && (
          <span style={{ marginLeft: '0.5em' }}>
            <TooltipHost
              content={<span dangerouslySetInnerHTML={{ __html: tooltip }} />}
              id={this.hostId}
              calloutProps={{ gapSpace: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <Icon iconName="Info" />
            </TooltipHost>
          </span>
        )}
      </Fragment>
    );

    return (
      <Toggle
        inlineLabel
        label={
          <Fragment>
            {label}
            {tooltipIcon}
          </Fragment>
        }
        role="checkbox"
        aria-checked={checked}
        checked={checked}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ToggleField/index.jsx